export default __webpack_public_path__ + "static/media/FETCH.941cafee.svg";